import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import CTAButtons from "@/pages/manchester/CTAButtons";

const faqs = [
  {
    q: "How much more can I earn with short-let vs long-term rent?",
    a: "Most landlords earn 40–80% more than their previous AST tenancy. A 1-bed in Manchester that rented for £900/month on a long-term let typically earns £1,400–£2,200/month with us. We'll give you a specific estimate for your property before you commit to anything.",
  },
  {
    q: "What's included in your management fee?",
    a: "Everything. Listing creation, photography, pricing, guest communication, check-in, cleaning coordination, maintenance, reviews, and monthly reporting. Our fee starts from 12% + VAT - there are no setup fees and no lock-in contracts.",
  },
  {
    q: "How quickly can my property go live?",
    a: "Most properties go live within 7 days of signing up. We arrange photography within 2–3 days, handle all listing setup ourselves, and have your property active on Airbnb and 15+ other platforms by day 7.",
  },
  {
    q: "What if I want to use my property myself?",
    a: "You stay in control. Block any dates you want through your owner dashboard - there's no minimum availability requirement. Unlike a fixed tenancy, your property stays flexible.",
  },
  {
    q: "How does guest screening work?",
    a: "Every guest is ID-verified through Airbnb or our own verification system before check-in. We require rental agreements for all bookings and hold a security deposit. We also use smart property monitoring to detect parties and unauthorised guests.",
  },
  {
    q: "Do I need to be there for check-ins?",
    a: "Not at all - we handle everything. All properties use smart lock or key-safe systems, and we send guests full arrival instructions ahead of their stay. You never need to be present.",
  },
  {
    q: "What areas do you cover?",
    a: "We currently manage properties across Manchester, Liverpool, London, Birmingham, Leeds, Sheffield, Brighton, Chester, Bath, Oxford, Stockport, Newcastle, Southampton, Essex, Slough and more. Get in touch if you're not sure whether your area is covered.",
  },
  {
    q: "What happens if a guest causes damage?",
    a: "We hold a deposit on every booking and have dedicated damage processes. Airbnb's AirCover also provides up to $3M in host damage protection. In the rare event of damage, we manage the claim process for you - you don't need to deal with it.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState(null);

  return (
    <section style={{
      backgroundColor: "#F4F1E7",
      paddingTop: "clamp(60px, 7vw, 96px)",
      paddingBottom: "clamp(60px, 7vw, 96px)",
      paddingLeft: "clamp(20px, 5vw, 80px)",
      paddingRight: "clamp(20px, 5vw, 80px)",
    }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 80, alignItems: "start" }} className="faq-grid">
          {/* Left */}
          <div style={{ position: "sticky", top: 100 }} className="faq-sticky-left">
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#5C7268", marginBottom: 14, marginTop: 0 }}>Common questions</p>
            <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(26px, 3vw, 40px)", letterSpacing: "-0.02em", lineHeight: 1.2, color: "#112215", marginTop: 0, marginBottom: 16 }}>
              Common questions answered.
            </h2>
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 15, color: "#5C7268", lineHeight: 1.65, marginTop: 0, marginBottom: 24 }}>
              If you don't see your question here, <a href="/support" style={{ color: "#CD533B", textDecoration: "none", fontWeight: 600 }}>get in touch</a> - we're happy to help.
            </p>
            <CTAButtons align="left" includeMicrocopy />
          </div>

          {/* Right - accordion */}
          <div>
            {faqs.map((faq, i) => (
              <div
                key={i}
                style={{ borderBottom: "1px solid #E8E4D5", paddingTop: 20, paddingBottom: 20 }}
              >
                <button
                  onClick={() => setOpen(open === i ? null : i)}
                  style={{
                    width: "100%", background: "none", border: "none", padding: 0, cursor: "pointer",
                    display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16, textAlign: "left",
                  }}
                >
                  <span style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: 15.5, color: "#112215", lineHeight: 1.4 }}>{faq.q}</span>
                  <div style={{ flexShrink: 0, width: 24, height: 24, borderRadius: "50%", background: open === i ? "#112215" : "#EDE9DC", display: "flex", alignItems: "center", justifyContent: "center", transition: "background 0.2s" }}>
                    {open === i
                      ? <Minus size={12} color="#fff" strokeWidth={2.5} />
                      : <Plus size={12} color="#5C7268" strokeWidth={2.5} />
                    }
                  </div>
                </button>
                {open === i && (
                  <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 14.5, color: "#5C7268", lineHeight: 1.7, margin: "14px 0 0 0" }}>
                    {faq.a}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .faq-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
          .faq-sticky-left { position: static !important; }
        }
      `}</style>
    </section>
  );
}